import { ReactNode } from 'react';
import classNames from 'classnames';
import { Tags } from '@forma/forma-ui-kit';
import Link from '@/components/Link';

import styles from './marketplace-items.module.css';

interface MarketplaceItemProps {
  id: string,
  icon: string,
  title: string,
  description?: string,
  labels: { id: string, name: string, color: string, backgroundColor: string }[],
  isNew?: boolean,
  isInstalled?: boolean,
}

export interface MarketplaceItemsProps {
  title?: ReactNode,
  items: MarketplaceItemProps[],
}

const MarketplaceItems = ({ title, items }: MarketplaceItemsProps) => {
  return (
    <div className={styles.root}>
      {title && (
        <div className={styles.title}>
          {title}
        </div>
      )}
      <div className={styles.items}>
        {items.map(({ id, icon, title, description, labels, isNew, isInstalled }) => (
          <Link className={styles.item} href={`/marketplace/${id}`} key={title}>
            {isNew && <span className={classNames(styles.badge, styles.new)}>Новое</span>}
            {isInstalled && <span className={classNames(styles.badge, styles.installed)}>Подключено</span>}

            <img src={icon} alt={title} className={styles.icon} />

            <div className={styles.itemContent}>
              <div className={styles.itemTitle}>{title}</div>
              {description && <p className={styles.itemDescription}>{description}</p>}

              <div className={styles.labels}>
                <Tags
                  items={labels}
                />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MarketplaceItems;
